import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface SubscriptionObject {
  id: number;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  slug: string;
  isActive: boolean;
  price: number;
  sort: number;
  type: number;
  validity: number;
  color: string;
}

export interface GiftUserObject {
  id: number;
  fullName: string;
  phone: string;
  email: string;
  userType: string;
  memberType: number;
}

export interface GiftPackageObject {
  id: number;
  titleEn: string;
  titleAr: string;
  daysCovered: number;
  price: number;
  iveCredits: number;
  adsCredits: number;
  specialAds: number;
  type: number;
  slug: string;
}

export interface SubscriptionListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  subscription: Array<SubscriptionObject>;
  errors: unknown;
}

export interface ChargeLogsFilterInfo {
  status: string;
  phone: number;
  service: string;
  paymentMethod: string;
  packageName: string;
  chargeId: string;
  platform: string;
}

export interface PurchaseLogsFilterInfo {
  dateFrom: string;
  dateTo: string;
  service: string;
  packageName: string;
  phone: string;
  memberType: string;
  platform: string;
  status: string;
}

@Module
export default class SubscriptionModule
  extends VuexModule
  implements SubscriptionListInfo
{
  subscription = [] as Array<SubscriptionObject>;
  chargeLogs = [] as Array<any>;
  purchaseLogs = [] as Array<any>;
  chargeLogsFilter = {} as ChargeLogsFilterInfo;
  purchaseLogsFilter = {} as PurchaseLogsFilterInfo;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  giftUsers = [] as Array<GiftUserObject>;
  giftPackages = [] as Array<GiftPackageObject>;
  giftUsersTotal = 0;

  chargeLogsTotalItems = 0;
  chargeLogsCurrentPage = 1;
  chargeLogsPageSize = 2;
  chargeLogsPrevious = 0;
  chargeLogsIsNext = true;

  purchaseLogsTotalItems = 0;
  purchaseLogsCurrentPage = 1;
  purchaseLogsPageSize = 2;
  purchaseLogsPrevious = 0;
  pruchaseLogsIsNext = true;

  /**
   * Get Ads list
   * @returns Array<AdsObject>
   */
  get subscriptionsList(): Array<SubscriptionObject> {
    return this.subscription;
  }

  /**
   * Get total items
   * @returns number
   */
  get subscriptionsListCount(): number {
    return this.totalItems;
  }

  get chargeLogsList(): Array<SubscriptionObject> {
    return this.chargeLogs;
  }

  get getchargeLogsFilter() {
    return this.chargeLogsFilter;
  }

  get purchaseLogsList(): Array<any> {
    return this.purchaseLogs;
  }

  get getPurchaseLogsFilter() {
    return this.purchaseLogsFilter;
  }

  /**
   * Get total items
   * @returns number
   */
  get chargeLogsCount(): number {
    return this.chargeLogsTotalItems;
  }

  get getpurchaseLogsCount(): number {
    return this.purchaseLogsTotalItems;
  }

  /**
   * Get gift users list
   * @returns Array<GiftUserObject>
   */
  get giftUsersList(): Array<GiftUserObject> {
    return this.giftUsers;
  }

  /**
   * Get gift users total
   * @returns number
   */
  get giftUsersListTotal(): number {
    return this.giftUsersTotal;
  }

  /**
   * Get gift packages list
   * @returns Array<GiftPackageObject>
   */
  get giftPackagesList(): Array<GiftPackageObject> {
    return this.giftPackages;
  }

  @Mutation
  [Mutations.SET_SUBSCRIPTIONS](data) {
    this.subscription = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_SUBSCRIPTIONS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_SUBSCRIPTION_LIST]() {
    this.subscription = [] as Array<SubscriptionObject>;
    this.chargeLogs = [] as Array<any>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_CHARGE_LOGS](data) {
    this.chargeLogs = data.data;
    this.chargeLogsTotalItems = data.totalItems;
    this.chargeLogsCurrentPage = data.currentPage;
    this.chargeLogsPageSize = data.pageSize;
    this.chargeLogsIsNext = data.isNext;
    this.chargeLogsPrevious = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_PURCHASE_LOGS](data) {
    this.purchaseLogs = data.data;
    this.purchaseLogsTotalItems = data.totalItems;
    this.purchaseLogsCurrentPage = data.currentPage;
    this.purchaseLogsPageSize = data.pageSize;
    this.pruchaseLogsIsNext = data.isNext;
    this.purchaseLogsPrevious = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_PURCHASE_LOGS_FILTER](obj) {
    this.purchaseLogsFilter.dateFrom = obj.dateFrom;
    this.purchaseLogsFilter.dateTo = obj.dateTo;
    this.purchaseLogsFilter.phone =
      obj.phone != '965' ? (obj.phone ? obj.phone : obj.phone) : '';
    this.purchaseLogsFilter.service = obj.service;
    this.purchaseLogsFilter.status = String(obj.status);
    this.purchaseLogsFilter.packageName = obj.packageName;
    this.purchaseLogsFilter.platform = obj.platform;
    this.purchaseLogsFilter.memberType = obj.memberType;
  }

  @Mutation
  [Mutations.SET_PURCHASE_LOGS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_PURCHASE_LOGS_STORE]() {
    this.purchaseLogs = [] as Array<any>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_CHARGE_LOGS_FILTER](obj) {
    this.chargeLogsFilter.status = String(obj.status);
    this.chargeLogsFilter.phone =
      obj.phone != '965' ? (obj.phone ? obj.phone : obj.phone) : '';
    this.chargeLogsFilter.service = obj.service;
    this.chargeLogsFilter.paymentMethod = obj.paymentMethod;
    this.chargeLogsFilter.packageName = obj.packageName;
    this.chargeLogsFilter.chargeId = obj.chargeId;
    this.chargeLogsFilter.platform = obj.platform;
  }

  @Mutation
  [Mutations.SET_CHARGE_LOGS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_CHARGE_LOGS_STORE]() {
    this.chargeLogs = [] as Array<any>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_GIFT_USERS](data) {
    this.giftUsers = data.data;
    this.giftUsersTotal = data.total;
    this.errors = {};
  }

  @Mutation
  [Mutations.RESET_GIFT_USERS]() {
    this.giftUsers = [] as Array<GiftUserObject>;
    this.giftUsersTotal = 0;
  }

  @Mutation
  [Mutations.SET_GIFT_PACKAGES](data) {
    this.giftPackages = data.data;
    this.errors = {};
  }

  @Mutation
  [Mutations.RESET_GIFT_PACKAGES]() {
    this.giftPackages = [] as Array<GiftPackageObject>;
  }

  @Action
  [Actions.RESET_SUBSCRIPTION_STORE]() {
    this.context.commit(Mutations.RESET_SUBSCRIPTION_LIST);
  }

  @Action
  [Actions.UPDATE_SUBSCRIPTIONS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_SUBSCRIPTIONS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_SUBSCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/subscriptions', id);
  }
  @Action
  [Actions.GET_PURCHASE_LOG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/subscriptions/purchase-logs', id);
  }

  @Action
  [Actions.GET_SUBSCRIPTIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/subscriptions', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        data.data = data.data.map((r) => {
          r.createdAt = new Date(r.createdAt)
            .toLocaleString('en-GB')
            .split(',')[0];
          return r;
        });
        this.context.commit(Mutations.SET_SUBSCRIPTIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.CREATE_AD_PACKAGE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/subscriptions', data)
      .then(() => {
        this.context.commit(Mutations.RESET_SUBSCRIPTION_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
  @Action
  [Actions.UPDATE_SUBSCRIPTION]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/subscriptions', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_SUBSCRIPTION_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_SUBSCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/subscriptions', id)
      .then(() => {
        this.context.commit(Mutations.RESET_SUBSCRIPTION_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_CHARGES_LOGS_FILTER](val) {
    this.context.commit(Mutations.SET_CHARGE_LOGS_FILTER, val);
  }

  @Action
  [Actions.GET_CHARGE_LOGS](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = {
      page: this.currentPage,
      limit: options.limit,
      phone: this.chargeLogsFilter.phone,
      service: this.chargeLogsFilter.service,
      paymentMethod: this.chargeLogsFilter.paymentMethod,
      status: this.chargeLogsFilter.status,
      chargeId: this.chargeLogsFilter.chargeId,
      packageName: this.chargeLogsFilter.packageName,
      platform: this.chargeLogsFilter.platform,
    };
    return ApiService.query('/subscriptions/charge-logs/history', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_CHARGE_LOGS, data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPDATE_CHARGE_LOGS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_CHARGE_LOGS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.UPDATE_PURCHASE_LOGS_FILTER](val) {
    this.context.commit(Mutations.SET_PURCHASE_LOGS_FILTER, val);
  }

  @Action
  [Actions.GET_PURCHASE_LOGS](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = {
      page: this.currentPage,
      limit: options.limit,
      dateFrom: this.purchaseLogsFilter.dateFrom,
      dateTo: this.purchaseLogsFilter.dateTo,
      phone: this.purchaseLogsFilter.phone,
      service: this.purchaseLogsFilter.service,
      status: this.purchaseLogsFilter.status,
      packageName: this.purchaseLogsFilter.packageName,
      platform: this.purchaseLogsFilter.platform,
      memberType: this.purchaseLogsFilter.memberType,
    };
    return ApiService.query('/subscriptions/purchase-logs/history', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PURCHASE_LOGS, data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPDATE_PURCHASE_LOGS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_PURCHASE_LOGS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.SEARCH_GIFT_USERS](params: {
    phone?: string;
    email?: string;
    page?: number;
    limit?: number;
  }) {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/subscriptions/gift/search-users', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_GIFT_USERS, data.data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.GET_GIFT_PACKAGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/subscriptions/gift/packages')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_GIFT_PACKAGES, data);
        return data;
      })
      .catch(({ response }) => {
        console.error(response);
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.ASSIGN_GIFT_PACKAGE](payload) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/subscriptions/gift/assign', payload)
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
        throw response;
      });
  }

  @Action
  [Actions.RESET_GIFT_USERS_STORE]() {
    this.context.commit(Mutations.RESET_GIFT_USERS);
  }

  @Action
  [Actions.RESET_GIFT_PACKAGES_STORE]() {
    this.context.commit(Mutations.RESET_GIFT_PACKAGES);
  }
}
